import { RRIBaseModel } from './base-model.interface';
import { RRIPagination } from './base-pagination.interface';
import { RRISort } from './base-sort.interface';
import { RRIFilterOutput } from './filters/filter-output.interface';

export interface RRIQueryParams<T extends RRIBaseModel, U> {
  sort?: RRISort<T>;
  filters?: RRIFilterOutput<U>[];
  pagination?: RRIPagination;
  includeResult?: boolean;
  tags?: { [tag: string]: string[] };
}
